<!-- Start of channel select menu  -->
<div class="border-r border-slate-200 relative flex flex-col gap-2 items-center py-4 px-1">
  <!-- Menu Toggle Button -->
  <button>
    <img class="w-[36px] h-[36px] hover:cursor-pointer" (click)="toggleSidenav()"
      src="{{sidenav().isExtended?'../../../assets/sidenav-collapsed.svg':'../../../assets/sidenav-expanded.svg'}}"
      alt="nav-control-icon">
  </button>

  <!-- Logo -->
  <img src="../../../assets/logo.png" alt="logo" class="w-[48px] h-[48px] {{sidenav().isExtended?'ml-auto':'mx-auto'}}">

  <!-- Voice/AI Agent Item -->
  <div class="relative group cursor-pointer transition-all duration-300"
    [class.asset-active]="selectedAsset()?.type === 'voice_agent'">

    <!-- Active Tab Indicator -->
    <div class="absolute -left-[1.2rem] top-0 w-4 h-full bg-[#2C283E]
                rounded-r-lg transition-all duration-300 ease-out
                opacity-0 translate-x-[-50%] shadow-lg shadow-blue-500/25
                [.asset-active_&]:opacity-100 [.asset-active_&]:translate-x-0"></div>

    <!-- Icon Container -->
    <button tp="Voice Agent" tpPlacement="right" (click)="handleAssetChange('voice_agent')"
      class="flex items-center justify-center p-2 rounded-[6px] transition-all duration-300 z-10 relative bg-gray-100 group-hover:bg-gray-200 [&.asset-active]:shadow-md">
      <img class="w-[20px] h-[20px] transition-colors duration-300"
        [src]="selectedAsset()?.type === 'voice_agent'?'../../../assets/voice-agent.svg':'../../../assets/voice-agent-inactive.svg'"
        alt="voice-agent-icon">
    </button>
  </div>

  <!-- Facebook/Meta Item -->
  <div class="relative group cursor-pointer transition-all duration-300"
    [class.asset-active]="selectedAsset()?.type === 'facebook'">

    <!-- Active Tab Indicator -->
    <div class="absolute -left-[1.2rem] top-0 w-4 h-full bg-[#2C283E]
                rounded-r-lg transition-all duration-300 ease-out
                opacity-0 translate-x-[-50%] shadow-lg shadow-blue-500/25
                [.asset-active_&]:opacity-100 [.asset-active_&]:translate-x-0"></div>

    <!-- Icon Container -->
    <button tp="Facebook Pages" tpPlacement="right" (click)="handleAssetChange('facebook')" class="flex items-center justify-center p-2 rounded-[6px] transition-all duration-300 z-10 relative
                bg-gray-100 group-hover:bg-gray-200
                [&.asset-active]:bg-blue-50 [&.asset-active]:shadow-md">
      <img class="w-[20px] h-[20px] transition-colors duration-300"
        [src]="selectedAsset()?.type === 'facebook'?'../../../assets/facebook-asset.svg':'../../../assets/facebook-asset-inactive.svg'"
        alt="facebook-icon">
    </button>
  </div>

  <!-- WhatsApp Item -->
  <div class="relative group cursor-pointer transition-all duration-300"
    [class.asset-active]="selectedAsset()?.type === 'waba'">

    <!-- Active Tab Indicator -->
    <div class="absolute -left-[1.2rem] top-0 w-4 h-full bg-[#2C283E]
                rounded-r-lg transition-all duration-300 ease-out
                opacity-0 translate-x-[-50%] shadow-lg shadow-blue-500/25
                [.asset-active_&]:opacity-100 [.asset-active_&]:translate-x-0"></div>

    <!-- Icon Container -->
    <button tp="Whatsapp Business Account" tpPlacement="right" (click)="handleAssetChange('waba')" class="flex items-center justify-center p-2 rounded-[6px] transition-all duration-300 z-10 relative
                bg-gray-100 group-hover:bg-gray-200
                [&.asset-active]:bg-blue-50 [&.asset-active]:shadow-md">
      <img class="w-[20px] h-[20px] transition-colors duration-300"
        [src]="selectedAsset()?.type === 'waba'?'../../../assets/waba-asset.svg':'../../../assets/waba-asset-inactive.svg'"
        alt="waba-icon">
    </button>
  </div>
</div>
<!-- End of channel select menu  -->

<!-- Start of sub menu/nav menu  -->
@if(showSubMenu()) {
<div
  class="h-full flex-1 md:h-[100vh] py-1 px-3 md:p-3 flex flex-col !z-20 transition-all duration-300 ease-in-out border-r"
  [ngClass]="!sidenav().isExtended?'w-[50px] md:w-[88px]':'w-full sm:w-[250px] !bg-white'">

  @if(sidenav().isExtended) {
  <div class="relative sidenavWaba rounded-xl">
    <p class="absolute z-[9999] text-xs top-[.75rem] text-slate-400 left-[.75rem]">{{typePlaceholder() || 'Account
      Type'}}</p>
    <ng-select #selectAsset [searchable]="false" class="my-2" [items]="[]">
      <ng-template ng-placeholder-tmp let-item="item">
        <div class="flex items-center gap-3" [class.animate-pulse]="!selectedAsset()?.type">
          @if(selectedAsset()?.type === 'facebook') {
          <img src="../../../assets/facebook-asset.svg" alt="facebook-icon" class="w-4 h-4">
          } @else if(selectedAsset()?.type === 'waba') {
          <img src="../../../assets/waba-asset.svg" alt="waba-icon" class="w-4 h-4">
          } @else {
          <img class="w-4 h-4" src="../../../assets/voice-agent.svg" alt="voice-agent-icon">
          }
          <p>{{(selectedAsset()?.page_name || selectedAsset()?.id || 'Voice Agent') | titlecase}}</p>
        </div>
      </ng-template>
      <ng-template ng-notfound-tmp>
        <div class="p-2 divide-y divide-gray-300 w-full max-w-sm">

          <div (click)="handleTypeChange(voice_agent(), true)" [ngClass]="{
              'text-[#2A5B8C] bg-[#BBDAF9]': selectedAsset()?.type === 'voice_agent',
              'hover:bg-gray-100 group-hover:text-gray-900': selectedAsset()?.type !== 'voice_agent'
            }"
            class="group relative flex items-center w-full my-1 p-2 rounded-md transition-all duration-150 cursor-pointer">
            <!-- Platform Header -->
            <div class="flex items-center gap-2 w-full">
              <div class="flex items-center justify-center p-2 bg-gray-100 rounded-[6px]">
                <img class="w-4 h-4" src="../../../assets/voice-agent.svg" alt="voice-agent-icon">
              </div>
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-gray-700">Voice Agent</span>
              </div>
            </div>
          </div>

          <div class="space-y-1 py-1">
            <!-- Platform Header -->
            <div class="flex items-center gap-2 px-2 py-1.5">
              <div class="flex items-center justify-center p-2 bg-gray-100 rounded-[6px]">
                <img src="../../../assets/facebook-asset.svg" alt="facebook-icon" class="w-4 h-4">
              </div>
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-gray-700">{{'Facebook Pages'}}</span>
              </div>
              <button (click)="linkAccount('facebook')"
                class="ml-auto flex items-center gap-2 text-gray-600 hover:text-black hover:bg-gray-100 p-2 rounded-lg">
                <i class="bx bx-xs font-semibold bx-plus"></i>
              </button>
            </div>

            <!-- Account List -->
            <div class="mt-0.5 space-y-0.5 pl-8">
              @for (item of FbPages(); track item) {
              <div (click)="handleTypeChange(item, true)" [ngClass]="{'text-[#2A5B8C] bg-[#BBDAF9]': item.id === selectedAsset()?.id,
                  'hover:bg-gray-100 group-hover:text-gray-900': item.id !== selectedAsset()?.id}"
                class="group relative flex items-center w-full my-1 p-2 rounded-md transition-all duration-150 cursor-pointer">
                <!-- Indicator Line -->
                <div
                  class="absolute -left-[11px] top-1/2 -translate-y-1/2 w-5 h-px bg-gray-300 group-hover:bg-gray-300">
                </div>

                <!-- Indicator Dot -->
                <div
                  class="absolute -left-[13px] top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-300 group-hover:bg-gray-50">
                </div>

                <!-- Account Name -->
                <span class="text-sm text-gray-600 ml-3">
                  {{(item?.page_name || item.id) | titlecase}}
                </span>
              </div>
              }
            </div>

            <!-- Empty State -->
            @if (FbPages().length === 0) {
            <div class="px-2 py-1.5 text-sm text-gray-500 italic">
              No accounts available
            </div>
            }
          </div>

          <div class="space-y-1 py-1">
            <!-- Platform Header -->
            <div class="flex items-center gap-2 px-2 py-1.5">
              <div class="flex items-center justify-center p-2 bg-gray-100 rounded-[6px]">
                <img src="../../../assets/waba-asset.svg" alt="waba-icon" class="w-4 h-4">
              </div>
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-gray-700">WhatsApp Business Accounts</span>
              </div>
              <button (click)="linkAccount('waba')"
                class="ml-auto flex items-center gap-2 text-gray-600 hover:text-black hover:bg-gray-100 p-2 rounded-lg">
                <i class="bx bx-xs font-semibold bx-plus"></i>
              </button>
            </div>

            <!-- Account List -->
            <div class="mt-0.5 space-y-0.5 pl-8">
              @for (item of wabas(); track item) {
              <div (click)="handleTypeChange(item, true)" [ngClass]="{'text-[#2A5B8C] bg-[#BBDAF9]': item.id === selectedAsset()?.id,
                  'hover:bg-gray-100 group-hover:text-gray-900': item.id !== selectedAsset()?.id
                }"
                class="group relative flex items-center w-full my-1 p-2 rounded-md transition-all duration-150 cursor-pointer">
                <!-- Indicator Line -->
                <div
                  class="absolute -left-[11px] top-1/2 -translate-y-1/2 w-5 h-px bg-gray-300 group-hover:bg-gray-300">
                </div>

                <!-- Indicator Dot -->
                <div
                  class="absolute -left-[13px] top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-300 group-hover:bg-gray-50">
                </div>

                <!-- Account Name -->
                <span class="text-sm text-gray-600 ml-3">
                  {{(item?.page_name || item.id) | titlecase}}
                </span>
              </div>
              }
            </div>

            <!-- Empty State -->
            @if (wabas().length === 0) {
            <div class="px-2 py-1.5 text-sm text-gray-500 italic">
              No accounts available
            </div>
            }
          </div>

        </div>
      </ng-template>
    </ng-select>
  </div>
  }@else {
  <div class="relative flex flex-col items-center py-2">
    <!-- Icon only display for collapsed state -->
    <div
      class="w-[63px] h-[54px] flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 cursor-pointer"
      (click)="toggleSidenav()" [title]="selectedAsset()?.page_name || selectedAsset()?.id || 'Select Account'">

      <i class="bx bx-chevron-right bx-sm"></i>
    </div>
  </div>
  }
  <div class="w-full h-[1px] bg-[#f6f6f6] my-1"></div>
  @for(menu of menus();track menu.link) {
  <button (mousedown)="navigate(menu)" [class.active]="currentUrl() === '/'+menu.link"
    [class.!cursor-not-allowed]="!menu.enabled"
    class="!flex items-center px-[20px] py-[12px] cursor-pointer rounded-[6px] hover:bg-gray-100 my-[2px] active:scale-90 md:opacity-0 zoomOut-animation"
    [style]="'animation-delay:'+($index+1) * 50+'ms'" [class.flex]="!sidenav().isExtended" [tp]="menu.name"
    tpPlacement="right" [tpIsEnabled]="!sidenav().isExtended" (click)="setLoading(menu, $event)">

    <div class="relative w-fit">
      @if(isLoading() && currentRoute() === menu.link) {
      <div class="flex items-center justify-center z-10 w-[20px] h-[20px]">
        <app-loader [theme]="'light'" [size]="'sm'"></app-loader>
      </div>
      } @else {
      <img [src]="currentUrl() === '/'+menu.link ? menu.icon_active : menu.icon" alt="icon"
        class="w-[20px] h-[20px] transition-opacity duration-200"
        [class.opacity-40]="isLoading() && currentRoute() === menu.link">

      @if(menu.name.includes('History')) {
      <div class="absolute bottom-0 right-[-4px] bg-slate-100 rounded-full">
        <img src="../../../assets/history.svg" alt="history-icon" class="w-4 h-4">
      </div>
      }
      }
    </div>

    <!-- Text with animation that won't affect layout -->
    <p class="flex items-center gap-2 leading-none text-nowrap absolute" [class]="sidenav().isExtended ?
                'opacity-100 translate-x-[2.5rem]' :
                'opacity-0 translate-x-0 pointer-events-none'">
      {{menu.name}}
      @if (!menu.enabled) {
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 20 20" stroke="currentColor">
        <rect x="4" y="9" width="12" height="7" rx="2" fill="#e5e7eb" stroke="#2C283E" stroke-width="1.5" />
        <path d="M7 9V7a3 3 0 1 1 6 0v2" stroke="#2C283E" stroke-width="1.5" stroke-linecap="round" />
        <circle cx="10" cy="13" r="1" fill="#2C283E" />
      </svg>
      }
    </p>
  </button>
  }
</div>
}
<!-- End of sub menu/nav menu  -->